import { Component, Inject, OnInit } from '@angular/core';
import { NgClass } from '@angular/common';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

export interface CustomMessageData {
  type?: string;
  title?: string;
  message?: string;
  loading?: boolean;
  duration?: number;
  dismissBtn?: boolean;
  dismissBtnText?: string;
  acceptBtn?: boolean;
  acceptBtnText?: string;
}

/**
 * Los cuatro tipos que la app realmente usa (`success`, `error`, `warning`,
 * `neutral`) y el icono de Material que le toca a cada uno. Cualquier otro
 * valor cae en `neutral` en vez de quedarse sin icono.
 */
const ICONOS: Record<string, string> = {
  success: 'check_circle',
  error:   'error',
  warning: 'warning',
  neutral: 'info',
};

const TIPO_POR_DEFECTO = 'neutral';

@Component({
  selector: 'app-custom-message',
  standalone: true,
  imports: [
    NgClass,
    MatDialogModule,
    MatButtonModule,
    MatDividerModule,
    MatIconModule,
    MatProgressSpinnerModule,
  ],
  templateUrl: './custom-message.component.html',
  styleUrls: ['./custom-message.component.scss'],
})
export class CustomMessageComponent implements OnInit {

  constructor(
    public dialogRef: MatDialogRef<CustomMessageComponent>,
    @Inject(MAT_DIALOG_DATA) public data: CustomMessageData
  ) {}

  /**
   * Antes el icono era `<img src="{{data.type}}.gif">` y el spinner
   * `<img src="loader.gif">`. No se veían por dos razones distintas, y las
   * dos había que arreglar:
   *
   *   1. Los .gif no existen. No hay UN SOLO archivo .gif en el proyecto:
   *      venían del shell viejo de Epione y nunca se migraron. La petición
   *      terminaba siempre en 404.
   *
   *   2. Aunque existieran, la ruta era RELATIVA y sin carpeta. El navegador
   *      la resuelve contra la URL actual, así que en `/users` pedía
   *      `/users.gif`, y en `/catalogues/warehouses` pedía
   *      `/catalogues/warehouses.gif`. Solo habría funcionado en la raíz.
   *
   * Ahora es un `mat-icon`, igual que el resto de la app: no depende de
   * archivos binarios, se pinta con los colores de la paleta y se ve nítido
   * en cualquier pantalla. El loader es un `mat-progress-spinner`.
   */
  tipo(): string {
    const t = (this.data.type ?? '').toLowerCase();
    return t in ICONOS ? t : TIPO_POR_DEFECTO;
  }

  icono(): string {
    return ICONOS[this.tipo()];
  }

  ngOnInit(): void {
    if (this.data.duration) {
      setTimeout(() => this.close(false), this.data.duration);
    }
  }

  close(response: boolean): void {
    this.dialogRef.close(response);
  }
}
